import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV, Environment, resolveTrendServiceUrl } from 'lib-trend-core';
import { Observable } from 'rxjs';

/**
 * Turns the relative endpoints the shared services use (`/chat/bootstrap`,
 * `/user/push-token`…) into absolute platform URLs — the same resolution the product's
 * `CustomHttp` applies, without its behaviour of sending every 401 to the product's
 * login page. Absolute URLs and relative asset paths pass untouched.
 */
@Injectable()
export class ChatAppApiUrlInterceptor implements HttpInterceptor {

  constructor(@Inject(ENV) private readonly environment: Environment) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith('/') || request.url.startsWith('//')) {
      return next.handle(request);
    }
    return next.handle(request.clone({ url: resolveTrendServiceUrl(request.url, this.environment) }));
  }
}
